var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgPillClose = function SvgPillClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 8,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 1.205 6.795.5 4 3.295 1.205.5.5 1.205 3.295 4 .5 6.795l.705.705L4 4.705 6.795 7.5l.705-.705L4.705 4 7.5 1.205Z",
    fill: "#111128"
  })));
};

export default SvgPillClose;